import { cn } from '@/lib/utils';

interface PlanProgressHeaderProps {
  message?: string;
  /** Slightly faster runner when true (e.g. during GENERATE_TRAINING_PLAN) */
  runnerFaster?: boolean;
  className?: string;
}

/**
 * Chat bubble header: animated runner + message.
 * Pure CSS animation, no JS timers.
 */
export function PlanProgressHeader({
  message = 'Coach is creating your plan…',
  runnerFaster = false,
  className,
}: PlanProgressHeaderProps) {
  return (
    <div
      className={cn('flex items-center gap-2 text-sm text-foreground', className)}
      role="status"
      aria-label="Plan in progress"
    >
      <span
        className={cn(
          'runner inline-block mr-1',
          runnerFaster && 'runner--fast'
        )}
        aria-hidden
      >
        🏃‍♂️
      </span>
      <span>{message}</span>
    </div>
  );
}
